import { render, staticRenderFns } from "./AlignRowCustoms.vue?vue&type=template&id=e303686a"
import script from "./AlignRowCustoms.vue?vue&type=script&lang=js"
export * from "./AlignRowCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports